import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PROBLEMA, SOLUCION } from './salesData';

/**
 * El problema real de quien hace keto: el aburrimiento. Y KETO 4P como la
 * salida práctica. Dos columnas confrontadas, sin promesas médicas.
 */
export function TransformationSection() {
  return <section id="transformacion" className="w-full border-b border-line bg-carbon" data-id="element-167" data-mp="2nwpelvot459b">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-168" data-mp="2j69008992dld">
        <div className="max-w-2xl" data-id="element-169" data-mp="2j4xv2542izso">
          <SectionTag data-id="element-170" data-mp="2e6webqu47ckd">Por qué se abandona keto</SectionTag>
          <h2 className="mt-4 font-condensed text-[2.1rem] uppercase leading-[0.95] text-bone sm:text-5xl" data-id="element-171" data-mp="2e7fkybebeej3">
            Keto no se abandona por falta de ganas.
            <span className="block text-glow-gold" data-id="element-172" data-mp="24985jwzoc4j7">Se abandona por aburrimiento.</span>
          </h2>
          <p className="mt-4 text-[1rem] leading-relaxed text-ash" data-id="element-173" data-mp="2074tp793exxe">
            El plan no falla el primer día. Falla la tercera semana, cuando ya comiste lo mismo diez
            veces y extrañás el pan.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-174" data-mp="k33roh2p0zye">
          {/* Antes */}
          <div className="flex h-full flex-col rounded-2xl border border-line bg-ink/60 p-6 sm:p-7" data-id="element-175" data-mp="5e7ksncdhszd">
            <h3 className="font-display text-[0.68rem] uppercase tracking-editorial text-keto-pizza" data-id="element-176" data-mp="acrb0zy01qxj">
              Lo que pasa hoy
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-177" data-mp="130n13lt2cklc">
              {PROBLEMA.map(item => <li key={item} className="flex gap-3 text-[0.95rem] leading-snug text-bone/70" data-id="element-178" data-mp="12yanfkuc8we3">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-keto-pizza" aria-hidden strokeWidth={3} data-id="element-179" data-mp="p388y9bfdypo" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Después */}
          <div className="flex h-full flex-col rounded-2xl border border-gold/35 bg-gold/[0.06] p-6 sm:p-7" style={{
          boxShadow: '0 30px 80px -50px rgba(255,196,0,0.6)'
        }} data-id="element-180" data-mp="3dqdbad0gx06g">
            <h3 className="font-display text-[0.68rem] uppercase tracking-editorial text-gold" data-id="element-181" data-mp="1ak63zcltp8ku">
              Con KETO 4P
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-182" data-mp="15k1pfs4h6nx9">
              {SOLUCION.map(item => <li key={item} className="flex gap-3 text-[0.95rem] leading-snug text-bone" data-id="element-183" data-mp="11jrgq7patjep">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-184" data-mp="wk54o1l7i97h" />
                  {item}
                </li>)}
            </ul>
            <div className="mt-auto pt-7" data-id="element-185" data-mp="molabjmajiku">
              <CTAButton data-id="element-186" data-mp="2lzl1qiluw4h0" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}